import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GerenciaArquivo } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { ModalLoadArquivoService } from 'src/app/services/load-arquivo/modal-arquivo.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-modal-load-arquivo',
  templateUrl: './modal-load-arquivo.component.html',
  styleUrls: ['./modal-load-arquivo.component.scss'],
})
export class ModalLoadArquivoComponent implements OnInit, OnDestroy {
  form = new FormGroup({
    clienteSelecionado: new FormControl(null, Validators.required),
    nomeArquivo: new FormControl(null, Validators.required),
    operacaoSelecionada: new FormControl(null, Validators.required),
  });

  get clienteSelecionado() {
    return this.form.get('clienteSelecionado').value;
  }
  get nomeArquivo() {
    return this.form.get('nomeArquivo').value;
  }
  get operacaoSelecionada() {
    return this.form.get('operacaoSelecionada').value;
  }
  file: File | null = null;
  usuario: any;
  public fileName: string = '';
  isLoading: any;
  modal: any;
  public listaClientes: any[];
  public listaOperacao: any[];
  private onDestroy = new Subject<void>();

  constructor(
    private ModalLoadArquivoService: ModalLoadArquivoService,
    public dialogRef: MatDialogRef<ModalLoadArquivoComponent>,
    private svc: ModalLoadArquivoService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.usuario = StorageService.getPerfilUsuario();

    this.svc.getClientesAtivos().subscribe((res) => {
      if (res) {
        this.listaClientes = res;
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
      this.fileName = this.file.name;
    } else {
      this.file = null;
      this.fileName = '';
    }
  }

  async UploadArquivoSalvar() {
    let usuario = this.usuario;
    //let cliente = this.listaClientes.find(x => x.clienteId === this.clienteSelecionado);
    let operacao = this.listaOperacao.find(
      (x) => x.operacao === this.operacaoSelecionada
    );
    if (!operacao) {
      this.openSnackBar(
        'Selecione uma operação válida.',
        'OK',
        5000,
        'danger-snackbar'
      );
      return;
    }

    let diretorio = `\\\\${operacao.ipServidor}\\${operacao.diretorio}`;
    const formData = new FormData();
    formData.append('diretorio', diretorio);
    formData.append('arquivo', this.file, this.fileName);
    formData.append('nome', this.fileName);
    formData.append('clienteId', operacao.clienteId);
    formData.append('usuario', usuario.username);
    formData.append('cliente', operacao.nome);

    const response = await this.ModalLoadArquivoService.UploadArquivoSalvar(
      formData
    )
      .toPromise()
      .then(
        (response: any) => {
          if (response && response.sucesso) {
            this.openSnackBar(
              response.mensagem,
              'OK',
              5000,
              'success-snackbar'
            );
            this.dialogRef.close();
          } else {
            this.openSnackBar(response.mensagem, 'OK', 5000, 'danger-snackbar');
          }
        },
        (err: HttpErrorResponse) => {
          console.error();
          this.openSnackBar(
            'Erro ao cadastrar o arquivo, ' + err.error.Errors[0].Message,
            'OK',
            5000,
            'danger-snackbar'
          );
        }
      );
  }

  selecionarCliente() {
    const clienteId = this.clienteSelecionado;

    if (clienteId) {
      const cliente = this.listaClientes.find((x) => x.clienteId === clienteId);

      if (cliente) {
        this.svc.getOperacao(this.clienteSelecionado).subscribe((operacoes) => {
          if (operacoes) {
            this.listaOperacao = operacoes;
            this.form.get('operacao')?.updateValueAndValidity();
          }
        });
      }
    }
  }

  private openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
